export type NotificationOutboxItem = {
  id: number;
  kind: string;
  ref_id: string | number | null;
  title: string;
  body: string | null;
  link: string | null;
};

export type NotificationTickItem = {
  row: NotificationOutboxItem;
  shouldShow: boolean;
};

// 토스트 폭주 방지를 위해 한 틱에 "새로 표출하는" 알림만 2건으로 제한한다.
// ⚠ 이미 표출한 항목(폴링·푸시 토스트로 본 것)은 이 2건 한도를 소모하지 않는다 —
//   소모하게 두면 미읽음이 쌓였을 때 읽음 처리가 틱당 2건씩만 진행돼
//   목록 뒤쪽의 새 알림이 몇 분씩 밀린다(sent_at 오름차순 조회).
const MAX_NEW_TOASTS_PER_TICK = 2;

export function planNotificationTick(
  rows: NotificationOutboxItem[],
  hasShown: (kind: string, refId: string) => boolean,
): NotificationTickItem[] {
  const plan: NotificationTickItem[] = [];
  let toastBudget = MAX_NEW_TOASTS_PER_TICK;

  for (const row of rows) {
    const refId = String(row.ref_id ?? "");
    if (hasShown(row.kind, refId)) {
      // 표출은 건너뛰고 읽음 처리만 — 한도와 무관하게 정리한다.
      plan.push({ row, shouldShow: false });
      continue;
    }
    if (toastBudget === 0) break; // 남은 새 알림은 다음 틱으로
    toastBudget -= 1;
    plan.push({ row, shouldShow: true });
  }

  return plan;
}
